import React from 'react'
import PropTypes from 'prop-types'
import Toggler from 'hoc/toggler'
import TCol from './table-column'

const TableRowDropdown = ({ children, classes, togglerColClass = 'px-3 cursor-pointer', isOpen, toggle, PassedComponent }) => (
  <>
    <tr className={classes}>
      <TCol classes={togglerColClass} onClick={toggle}>
        <i className={`fa ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true" />
      </TCol>
      {children}
    </tr>
    {isOpen && (
      <tr>
        <td />
        <td colSpan="100%">
          <PassedComponent />
        </td>
      </tr>
    )}
  </>
)

TableRowDropdown.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
  togglerColClass: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  PassedComponent: PropTypes.func,
}

export default Toggler(TableRowDropdown)
